import React, {useContext, useState, useEffect} from "react"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import TranslationContext from "../../../../context/TranslationContext"
import ru from 'react-phone-input-2/lang/ru.json'
import es from 'react-phone-input-2/lang/es.json'
import fr from 'react-phone-input-2/lang/fr.json'
import ar from 'react-phone-input-2/lang/ar.json'
import de from 'react-phone-input-2/lang/de.json'
import cn from 'react-phone-input-2/lang/cn.json'
import css from './phoneInput.css'
import { getState } from "../helpers"

const PhoneInsertField = ({phoneSetter, value, turnOffStatus = false}) => {
    const {language} = useContext(TranslationContext)

    // const [loc, setlocalization] = useState({data: {}})

    const [disabled, setDisabled] = useState(false)
    const [val, setVal] = useState(value)

    useEffect(()=>{
        if (getState("user_phone") !== null) {
            setVal(getState("user_phone"))
            phoneSetter(getState("user_phone"))
        }
    },[])

    useEffect(() => {
        setDisabled(turnOffStatus)
    }, [turnOffStatus])

    // // TODO fix...
    // const m = {
    //     "ru": ru,"es": es, "de": de,
    //     "fr": fr, "ar": ar, "cn": cn, "en":{}
    // };
    // const LangTranslation = ["ru", "en", "es", "de", "zh", "ar", "fr"]

    // useEffect(() => {

    //   if (LangTranslation.includes(language)) {
    //     console.log("set lng", language, m[language])
    //     setlocalization({data: m[language]})
    //   } else {
    //     setlocalization({data: {}})
    //   }
    //   console.log("phone code book set lng", language, loc.data)
    // }, [language])

    const phoneInputHandler = (evt) => {
        phoneSetter(evt)
        setVal(evt)
    }

    return (
        <>
            { (language === "ru") ? <RUPhone
                val={val}
                phoneInputHandler={phoneInputHandler}
                disabled={disabled}
                /> :
                 <ENPhone
                 val={val}
                 phoneInputHandler={phoneInputHandler}
                 disabled={disabled}
                />
            }

        </>
    )
}


export default PhoneInsertField

export const RUPhone = (props) => {
    return (<PhoneInput
        value={props.val}
        localization={ru}
        country={'ru'}
        placeholder={'7 (XXX) XXX-XX-XX'}
        onChange={props.phoneInputHandler}
        inputClass="element-radius"
        disabled={props.disabled}
        disableDropdown={true}
        />)
}

export const ENPhone = (props) => {
    return (<PhoneInput
        value={props.val}
        country={'ru'}
        placeholder={'7 (XXX) XXX-XX-XX'}
        onChange={props.phoneInputHandler}
        inputClass="element-radius"
        disabled={props.disabled}
        disableDropdown={true}
        />)
}